import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { Toaster, ToasterPortalProvider } from '@surface/components';

import { LayoutProvider } from '@/components/layout/layout-provider';
import { ComponentAnalyticsProvider } from '@/lib/analytics/component-analytics-provider';
import {
  AuthProvider,
  TenantChangeOverlay,
  TenantChangeProvider,
} from '@/lib/auth';
import { AmplitudeExperimentProvider } from '@/lib/feature-flags/amplitude-experiment-context';
import { useClearPropertySelectionOnLogout } from '@/lib/hooks/use-clear-property-selection-on-logout';
import { KnockNotificationsProvider } from '@/lib/knock/knock-provider';
import { UploadsProvider } from '@/lib/uploads/uploads-provider';
import { queryClient } from '@/query-client';
import { LazyRouterProvider } from '@/router/lazy-router-provider';
import { uploadKinds } from '@/upload-kinds';

import '../globals.css';

function PropertySelectionStorageLifecycle() {
  useClearPropertySelectionOnLogout();
  return null;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToasterPortalProvider>
        <ComponentAnalyticsProvider>
          <LayoutProvider>
            <TenantChangeProvider>
              <AuthProvider>
                <AmplitudeExperimentProvider>
                  <PropertySelectionStorageLifecycle />
                  <KnockNotificationsProvider>
                    <UploadsProvider kinds={uploadKinds}>
                      <LazyRouterProvider />
                      <TenantChangeOverlay />
                    </UploadsProvider>
                  </KnockNotificationsProvider>
                </AmplitudeExperimentProvider>
              </AuthProvider>
            </TenantChangeProvider>
          </LayoutProvider>
          <ReactQueryDevtools />
          <Toaster position="bottom-right" />
        </ComponentAnalyticsProvider>
      </ToasterPortalProvider>
    </QueryClientProvider>
  );
}
